import {createAction} from 'redux-actions';
import {WINDOW_PAGE, GET_ERROR_404} from '../../systems/globalContant/actionContant';

export const eventUpdateLayout = createAction(WINDOW_PAGE.UPDATE_LAYOUT, (value) => ({value}));
export const eventClearError404 = createAction(GET_ERROR_404.CLEAR, (value) => ({value}));